import Abstract from './Abstract.js';

export default class Row extends Abstract {
  constructor(props) {
    super(props);
    this.row = null;
  }

  build() {
    const {
      chart,
      data,
      options: { barHeight },
    } = this.props;

    const group = chart
      .selectAll('svg')
      .data(data.rows)
      .enter()
      .append('g')
      .attr('class', 'row-group');
    this.row = group
      .append('rect')
      .attr('class', (d) => `bar bar--${d.impact || 'default'}`)
      .attr('rx', 10)
      .attr('ry', 10)
      .attr('height', barHeight)
      .attr('width', (d) => this.getWidth(d))
      .attr('x', (d) => this.getStartX(d))
      .attr('y', (d) => this.getStartY(d));
  }

  update() {
    this.row
      .transition()
      .duration(this.transitionDuration)
      .attr('x', (d) => this.getStartX(d));
  }

  getStartX(datum) {
    return this.xScale(datum.startDate);
  }

  getEndX(datum) {
    return this.xScale(datum.endDate);
  }

  getVisibleStartX(datum) {
    return Math.max(this.rangeStart, this.getStartX(datum));
  }

  getVisibleEndX(datum) {
    return Math.min(this.rangeEnd, this.getEndX(datum));
  }

  getWidth(datum) {
    return this.getEndX(datum) - this.getStartX(datum);
  }

  getVisibleWidth(datum) {
    return this.getVisibleEndX(datum) - this.getVisibleStartX(datum);
  }

  getStartY(datum) {
    return this.yScale(datum.row);
  }
}
